import React from 'react';
import { StyledTable } from './TableColumnStyle';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

export const requestsColumns = ({
  t,
  lang,
  pageNumber,
  filter,
  modalProlong,
  downloadAppointments,
  modalDeclineVoucher,
  checkBulletins
}) => {
  return [
    {
      Cell: row => (
        <Column
          data={row.original}
          index={row.index}
          t={t}
          lang={lang}
          pageNumber={pageNumber}
          filter={filter}
          modalProlong={modalProlong}
          downloadAppointments={downloadAppointments}
          modalDeclineVoucher={modalDeclineVoucher}
          checkBulletins={checkBulletins}
        />
      )
    }
  ];
};

const Column = ({
  data,
  t,
  lang,
  pageNumber,
  filter,
  index,
  modalProlong,
  downloadAppointments,
  modalDeclineVoucher,
  checkBulletins
}) => {
  const shouldProlong =
    !data.prolongedArriveDeadline &&
    moment() >= moment(data.arriveDeadline).subtract(1, 'day');

  return (
    <StyledTable>
      <div className="row1">
        <div className="col1">
          <div>
            <b>{(pageNumber - 1) * filter.pageSize + index + 1}) </b>
            <b>{t('voucher_applications_childFIO')}:</b>{' '}
            {`${data?.childSurname || ''} ${data?.childName ||
              ''} ${data?.childMiddleName || ''}`}
          </div>
        </div>
        <div className="col2">
          <div style={{ marginBottom: '5px' }}>
            {data.appStatusWebStatus && data.appStatusWebStatus[`${lang}_name`]}
          </div>
          {data.status === 'ANNULLED' && data.annulledAt && (
            <div>
              <b>{t('voucher_appointments_annulledDate')}:</b>{' '}
              {moment(data.annulledAt).format('DD.MM.YYYY HH:mm:ss')}
            </div>
          )}
          {data.status === 'SELF_DECLINED' && data.annulledAt && (
            <div>
              <b>{t('voucher_appointments_selfDeclinedDate')}:</b>{' '}
              {moment(data.annulledAt).format('DD.MM.YYYY HH:mm:ss')}
            </div>
          )}
        </div>
      </div>
      <div className="row2">
        <div className="col2_1">
          <div>
            <b>{t('voucher_applications_childBirthday')}:</b>{' '}
            {moment(data.childBirthday).format('DD.MM.YYYY')}
          </div>
          <div>
            <b>{t('voucher_applications_childIin')}:</b> {data.childIin}
          </div>
          <div>
            <b>{t('voucher_appointments_voucherId')}:</b> {data.id}
          </div>
          <div>
            <b>{t('voucher_appointments_requestFormId')}:</b> {data.requestFormId}
          </div>
          <div>
            <b>{t('voucher_appointments_DOName')}:</b>{' '}
            {lang === 'ru' ? data.serviceProviderRuName : data.serviceProviderKkName}
          </div>
        </div>
        <div className="col2_2">
          <div>
            <b>{t('voucher_appointments_voucherIssueDate')}:</b>{' '}
            {moment(data.receiveDate).format('DD.MM.YYYY')}&nbsp;&nbsp;
            {moment(data.receiveDate).format('HH:mm:ss')}
          </div>
          <div>
            <b>{t('voucher_appointments_voucherValidityPeriod')}:</b>{' '}
            {moment(data.prolongedArriveDeadline ?? data.arriveDeadline).format(
              'DD.MM.YYYY'
            )}
            &nbsp;&nbsp;
            {moment(data.prolongedArriveDeadline ?? data.arriveDeadline).format(
              'HH:mm:ss'
            )}
          </div>
        </div>
        <div className="col2_3">
          {data && ['ARRIVED_TO_PO'].includes(data.status) && !data.waitingListId && (
            <div style={{ marginTop: '10px', marginBottom: '15px' }}>
              <Link
                to={{
                  pathname: `/kindergarten-reestr/voucherId=${data.id}&serviceProviderId=${data.serviceProviderId}`,
                  search: `?filter=${encodeURIComponent(
                    JSON.stringify({
                      locationCode: data.queuedRegion,
                      ageGroup: data.ageGroup
                    })
                  )}`
                }}
                style={{ textDecoration: 'none' }}
              >
                <Button variant="contained" size="small" className="tab_but">
                  {t('kindergarten_reestr_add_waitingList')}
                </Button>
              </Link>
            </div>
          )}

          {data && ['RECEIVED', 'NOT_ENROLLED_TO_PO'].includes(data.status) && (
            <div>
              <Button
                style={{ marginBottom: '10px' }}
                variant="contained"
                color="secondary"
                size="small"
                className="tab_but"
                onClick={() => {
                  if (data.status === 'RECEIVED') {
                    window.open(
                      '/services/create/voucher_acceptance_ddo_short',
                      '_blank'
                    );
                  } else if (data.status === 'NOT_ENROLLED_TO_PO') {
                    checkBulletins(data);
                  }
                }}
              >
                {t('voucher_appointments_enroll')}
              </Button>
            </div>
          )}

          {['RECEIVED', 'NOT_ENROLLED_TO_PO'].includes(data?.status) && shouldProlong && (
            <div>
              <Button
                onClick={() => modalProlong.open(data)}
                style={{ marginBottom: '10px' }}
                variant="contained"
                color="secondary"
                size="small"
                className="tab_but"
              >
                {t('voucher_appointments_prolong')}
              </Button>
            </div>
          )}
          {data &&
            ['RECEIVED', 'ARRIVED_TO_PO', 'NOT_ENROLLED_TO_PO'].includes(data.status) && (
              <div>
                <Button
                  style={{ marginBottom: '10px' }}
                  variant="contained"
                  size="small"
                  className="tab_but--reject"
                  onClick={() => modalDeclineVoucher.open(data)}
                >
                  {t('voucher_appointments_decline')}
                </Button>
              </div>
            )}

          {data.requestFormId && !['ANNULLED'].includes(data.status) && (
            <div style={{ marginTop: '10px', marginBottom: '10px' }}>
              <Button
                onClick={() => downloadAppointments(data.requestFormId)}
                variant="contained"
                color="secondary"
                size="small"
                className="tab_but"
              >
                {t('voucher_appointment_actionsDownload')}
              </Button>
            </div>
          )}
        </div>
      </div>
    </StyledTable>
  );
};
